import React from 'react';

import { useSoftwareVersionSelectFieldQuery } from 'generated/graphql';



export type IObject = {
  id: string;
  name: string;
};

export interface IData {
  objects: IObject[];
}


export function useQuery(storeId: string) {
  const queryTuple = useSoftwareVersionSelectFieldQuery({
    variables: {
      storeId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        objects: queryTuple.data?.store?.softwareVersions.map((version): IObject => ({
          id: version.id,
          name: version.name
        })) ?? []
      };

      return {
        loading: queryTuple.loading,
        data,
        refetch: async () => {
          queryTuple.refetch();
        }
      };
    },
    [queryTuple]
  );
}
